<!-- Datos de operación (ui-redesign): KPI tiles agrupados por tema — lectura
     (valor+unidad+etiqueta) / edición (campo .ds en el mismo tile). Visibilidad
     por tipo de instalación data-driven vía parent.isInstFieldVisible(...). -->
<div class="cards">
  <div class="card">
    <div class="sec-head">
      <span class="sec-tile green"><mat-icon>settings</mat-icon></span>
      <div>
        <h3>{{ "centro.centroData.operationData" | translate }}</h3>
        <p>{{ "centro.detail.operationSub" | translate }}</p>
      </div>
    </div>

    <form [formGroup]="myOperationForm">
      <!-- ===== Energía ===== -->
      <div class="kt-group" *ngIf="parent.anyInstFieldVisible(G_ENERGIA)">
        <h4 class="kt-group-h"><mat-icon>bolt</mat-icon>{{ "centro.kpi.gEnergia" | translate }}</h4>
        <div class="kt-grid">
          <div class="kt" *ngIf="parent.isInstFieldVisible('consumoEnergeticoAnual')" [class.is-empty]="!editing && !has('conEnerAn')">
            <span class="kt-ic"><mat-icon>bolt</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("conEnerAn") }}<span class="kt-u" *ngIf="has('conEnerAn')">kWh/año</span></div>
              <div class="kt-l">{{ "centro.kpi.conEnerAn" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.conEnerAn" | translate }}<span class="kt-u">kWh/año</span></label>
                <div class="ff-box"><input type="number" formControlName="conEnerAn" noDecimalNumber /></div>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('consumoEnergeticoAutoproducido')" [class.is-empty]="!editing && !has('conEnerAnAut')">
            <span class="kt-ic"><mat-icon>solar_power</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("conEnerAnAut") }}<span class="kt-u" *ngIf="has('conEnerAnAut')">kWh/año</span></div>
              <div class="kt-l">{{ "centro.kpi.conEnerAnAut" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.conEnerAnAut" | translate }}<span class="kt-u">kWh/año</span></label>
                <div class="ff-box"><input type="number" formControlName="conEnerAnAut" noDecimalNumber /></div>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('bonifPenalEnergetica')" [class.is-empty]="!editing && !has('primaIncluidaID')">
            <span class="kt-ic"><mat-icon>request_quote</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(primaIncluidaList, "primaIncluidaID", "centro.energyBonuses.") }}</div>
              <div class="kt-l">{{ "centro.kpi.bonif" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.bonif" | translate }}</label>
                <app-ds-select formControlName="primaIncluidaID" [options]="primaIncluidaList" [optionLabel]="energyBonusLabelOf"></app-ds-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Agua producto ===== -->
      <div class="kt-group" *ngIf="parent.anyInstFieldVisible(G_AGUA_PRODUCTO)">
        <h4 class="kt-group-h"><mat-icon>water_drop</mat-icon>{{ "centro.kpi.gAguaProducto" | translate }}</h4>
        <div class="kt-grid">
          <div class="kt" *ngIf="parent.isInstFieldVisible('usoPriAguaProd')" [class.is-empty]="!editing && !has('usoPriAguaProdID')">
            <span class="kt-ic"><mat-icon>water_drop</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(usoAguaProductoList, "usoPriAguaProdID", "centro.tipoAgua.") }}</div>
              <div class="kt-l">{{ "centro.kpi.usoPriAguaProd" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.usoPriAguaProd" | translate }}</label>
                <app-ds-select formControlName="usoPriAguaProdID" [options]="usoAguaProductoList" [optionLabel]="tipoAguaLabelOf"></app-ds-select>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('usoPriPorc')" [class.is-empty]="!editing && !has('usoPriPorc')">
            <span class="kt-ic"><mat-icon>percent</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("usoPriPorc") }}<span class="kt-u" *ngIf="has('usoPriPorc')">%</span></div>
              <div class="kt-l">{{ "centro.kpi.usoPriPorc" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.usoPriPorc" | translate }}<span class="kt-u">%</span></label>
                <div class="ff-box"><input type="number" min="0.00" max="100.00" step="0.01" formControlName="usoPriPorc" twoDecimalNumber /></div>
                <small class="ff-error" *ngIf="(myOperationForm.get('usoPriPorc').hasError('max') || myOperationForm.get('usoPriPorc').hasError('min')) && myOperationForm.get('usoPriPorc').touched">{{ "messages.maxminValue" | translate }}</small>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('usoSecAguaProd')" [class.is-empty]="!editing && !has('usoSecAguaProdID')">
            <span class="kt-ic"><mat-icon>opacity</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(usoAguaProductoList, "usoSecAguaProdID", "centro.tipoAgua.") }}</div>
              <div class="kt-l">{{ "centro.kpi.usoSecAguaProd" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.usoSecAguaProd" | translate }}</label>
                <app-ds-select formControlName="usoSecAguaProdID" [options]="usoAguaProductoList" [optionLabel]="tipoAguaLabelOf"></app-ds-select>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('usoSecPorc')" [class.is-empty]="!editing && !has('usoSecPorc')">
            <span class="kt-ic"><mat-icon>percent</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("usoSecPorc") }}<span class="kt-u" *ngIf="has('usoSecPorc')">%</span></div>
              <div class="kt-l">{{ "centro.kpi.usoSecPorc" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.usoSecPorc" | translate }}<span class="kt-u">%</span></label>
                <div class="ff-box"><input type="number" min="0.00" max="100.00" step="0.01" formControlName="usoSecPorc" twoDecimalNumber /></div>
                <small class="ff-error" *ngIf="(myOperationForm.get('usoSecPorc').hasError('max') || myOperationForm.get('usoSecPorc').hasError('min')) && myOperationForm.get('usoSecPorc').touched">{{ "messages.maxminValue" | translate }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Agua regenerada ===== -->
      <div class="kt-group" *ngIf="parent.anyInstFieldVisible(G_AGUA_REGENERADA)">
        <h4 class="kt-group-h"><mat-icon>recycling</mat-icon>{{ "centro.kpi.gAguaRegenerada" | translate }}</h4>
        <div class="kt-grid">
          <div class="kt" *ngIf="parent.isInstFieldVisible('usoPriAguaRege')" [class.is-empty]="!editing && !has('usoPriAguaRegeID')">
            <span class="kt-ic"><mat-icon>recycling</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(usoAguaRegeneradaList, "usoPriAguaRegeID", "centro.tipoAgua.") }}</div>
              <div class="kt-l">{{ "centro.kpi.usoPriAguaRege" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.usoPriAguaRege" | translate }}</label>
                <app-ds-select formControlName="usoPriAguaRegeID" [options]="usoAguaRegeneradaList" [optionLabel]="tipoAguaLabelOf"></app-ds-select>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('usoPriPorcRege')" [class.is-empty]="!editing && !has('usoPriPorcRege')">
            <span class="kt-ic"><mat-icon>percent</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("usoPriPorcRege") }}<span class="kt-u" *ngIf="has('usoPriPorcRege')">%</span></div>
              <div class="kt-l">{{ "centro.kpi.usoPriPorcRege" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.usoPriPorcRege" | translate }}<span class="kt-u">%</span></label>
                <div class="ff-box"><input type="number" min="0.00" max="100.00" step="0.01" formControlName="usoPriPorcRege" twoDecimalNumber /></div>
                <small class="ff-error" *ngIf="(myOperationForm.get('usoPriPorcRege').hasError('max') || myOperationForm.get('usoPriPorcRege').hasError('min')) && myOperationForm.get('usoPriPorcRege').touched">{{ "messages.maxminValue" | translate }}</small>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Volúmenes e indicadores ===== -->
      <div class="kt-group" *ngIf="parent.anyInstFieldVisible(G_VOLUMENES)">
        <h4 class="kt-group-h"><mat-icon>waves</mat-icon>{{ "centro.kpi.gVolumenes" | translate }}</h4>
        <div class="kt-grid">
          <div class="kt" *ngIf="parent.isInstFieldVisible('prodAgua')" [class.is-empty]="!editing && !has('producAgua')">
            <span class="kt-ic"><mat-icon>opacity</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("producAgua") }}<span class="kt-u" *ngIf="has('producAgua')">m³</span></div>
              <div class="kt-l">{{ "centro.kpi.prodAgua" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.prodAgua" | translate }}<span class="kt-u">m³</span></label>
                <div class="ff-box"><input type="number" formControlName="producAgua" /></div>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('volAguaDist')" [class.is-empty]="!editing && !has('volumenFacturado')">
            <span class="kt-ic"><mat-icon>receipt_long</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("volumenFacturado") }}<span class="kt-u" *ngIf="has('volumenFacturado')">m³</span></div>
              <div class="kt-l">{{ "centro.kpi.volFacturado" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.volFacturado" | translate }}<span class="kt-u">m³</span></label>
                <div class="ff-box"><input type="number" formControlName="volumenFacturado" noDecimalNumber /></div>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('volCaudalRecog')" [class.is-empty]="!editing && !has('voluRecoSan')">
            <span class="kt-ic"><mat-icon>waves</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("voluRecoSan") }}<span class="kt-u" *ngIf="has('voluRecoSan')">m³</span></div>
              <div class="kt-l">{{ "centro.kpi.volRecogido" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.volRecogido" | translate }}<span class="kt-u">m³</span></label>
                <div class="ff-box"><input type="number" formControlName="voluRecoSan" noDecimalNumber /></div>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('iLI')" [class.is-empty]="!editing && !has('iLI')">
            <span class="kt-ic"><mat-icon>speed</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("iLI") }}</div>
              <div class="kt-l">{{ "centro.kpi.ili" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.ili" | translate }}</label>
                <div class="ff-box"><input type="number" step="0.01" formControlName="iLI" twoDecimalNumber /></div>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('poblaAbaste')" [class.is-empty]="!editing && !has('poblaAbaste')">
            <span class="kt-ic"><mat-icon>location_city</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v">{{ fmt("poblaAbaste") }}<span class="kt-u" *ngIf="has('poblaAbaste')">hab.</span></div>
              <div class="kt-l">{{ "centro.kpi.poblaAbaste" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.poblaAbaste" | translate }}<span class="kt-u">hab.</span></label>
                <div class="ff-box"><input type="number" formControlName="poblaAbaste" noDecimalNumber /></div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Procesos de tratamiento ===== -->
      <div class="kt-group" *ngIf="parent.anyInstFieldVisible(G_PROCESOS)">
        <h4 class="kt-group-h"><mat-icon>science</mat-icon>{{ "centro.kpi.gProcesos" | translate }}</h4>
        <div class="kt-grid">
          <div class="kt" *ngIf="parent.isInstFieldVisible('desnitrificacion')" [class.is-empty]="!editing && !has('desnitrificacionID')">
            <span class="kt-ic"><mat-icon>science</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(desnitrificacionList, "desnitrificacionID", "centro.desnitrifications.") }}</div>
              <div class="kt-l">{{ "centro.kpi.desnitrificacion" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.desnitrificacion" | translate }}</label>
                <app-ds-select formControlName="desnitrificacionID" [options]="desnitrificacionList" [optionLabel]="desnitrificacionLabelOf"></app-ds-select>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('digestAnaerobea')" [class.is-empty]="!editing && !has('digestionAnaerobiaFangoID')">
            <span class="kt-ic"><mat-icon>biotech</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(digestionAnaerobiaFangoList, "digestionAnaerobiaFangoID", "centro.anaerobicDigestions.") }}</div>
              <div class="kt-l">{{ "centro.kpi.digestion" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.digestion" | translate }}</label>
                <app-ds-select formControlName="digestionAnaerobiaFangoID" [options]="digestionAnaerobiaFangoList" [optionLabel]="digestionLabelOf"></app-ds-select>
              </div>
            </div>
          </div>

          <div class="kt" *ngIf="parent.isInstFieldVisible('recuperacionFosforo')" [class.is-empty]="!editing && !has('recupFosforoID')">
            <span class="kt-ic"><mat-icon>grain</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ selLabel(recuperacionFosforoList, "recupFosforoID", "centro.retrieveMatches.") }}</div>
              <div class="kt-l">{{ "centro.kpi.recupFosforo" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.recupFosforo" | translate }}</label>
                <app-ds-select formControlName="recupFosforoID" [options]="recuperacionFosforoList" [optionLabel]="recupFosforoLabelOf"></app-ds-select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ===== Gestión (siempre visible) ===== -->
      <div class="kt-group">
        <h4 class="kt-group-h"><mat-icon>tag</mat-icon>{{ "centro.kpi.gGestion" | translate }}</h4>
        <div class="kt-grid">
          <div class="kt" [class.is-empty]="!editing && !has('cecoaCentro')">
            <span class="kt-ic"><mat-icon>tag</mat-icon></span>
            <div class="kt-body" *ngIf="!editing">
              <div class="kt-v is-text">{{ has("cecoaCentro") ? myOperationForm.get("cecoaCentro").value : "—" }}</div>
              <div class="kt-l">{{ "centro.kpi.cecoa" | translate }}</div>
            </div>
            <div class="kt-body kt-edit" *ngIf="editing">
              <div class="ff-field">
                <label>{{ "centro.kpi.cecoa" | translate }}</label>
                <div class="ff-box"><input type="text" formControlName="cecoaCentro" /></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
